// extracted by mini-css-extract-plugin
export var actions = "_kf-g";
export var benefitCard = "_kf-b";
export var benefitIcon = "_kf-d";
export var benefitLabel = "_kf-f";
export var benefits = "_kf-a";
export var benefitsSection = "_kf-8";
export var bodyText = "_kf-7";
export var closeButton = "_kf-2";
export var content = "_kf-3";
export var eyebrow = "_kf-4";
export var heading = "_kf-5";
export var image = "_kf-i";
export var imagePanel = "_kf-h";
export var modal = "_kf-0";
export var offerCard = "_kf-c";
export var offerIcon = "_kf-e";
export var sectionLabel = "_kf-9";
export var shell = "_kf-1";
export var title = "_kf-6";